import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const BuyCallSvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.02084 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.29557 23.2032H16.8586L21.0455 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M21.1758 18.0225L30.6229 6.18964" stroke="#089981" strokeWidth="2"/>
    </svg>
)
const BuyCall: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {BuyCallSvg(props)}
    </SvgIcon>
));
export default BuyCall